module.exports = __webpack_public_path__ + "static/homepage-commentary-a99e498bca7d70b55f2696b61f85adea.png";